import Head from "next/head";
import query from "utils/query";
import Breadcrumb from "components/global/breadcrumbs";
import Manufacturers from "components/manufacturers/manufacturers";
import Config from "components/config";

// used for get static props
import MANUFACTURERS_QUERY from "queries/manufacturers";

export default function AllManufacturers({ fallback }) {
  const breadcrumbs = [];
  breadcrumbs.push({
    name: "All Manufacturers",
    link: "/manufacturers",
    linkAs: `/manufacturers`,
  });
  return (
    <Config fallback={fallback}>
      <Head>
        <title>Manufacturers - Open Coaster</title>
      </Head>
      <main className="container m-6 mx-auto px-6 sm:px-0">
        <Breadcrumb items={breadcrumbs} />
        <h2 className="mb-10 font-serif text-5xl text-gray-800">
          Manufacturers
        </h2>
        <Manufacturers />
      </main>
    </Config>
  );
}

export async function getStaticProps() {
  const fallback = {};

  const data = await Promise.all([query(MANUFACTURERS_QUERY)]);

  fallback[MANUFACTURERS_QUERY] = data[0];

  return {
    props: {
      fallback,
    },
  };
}